import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { LocationCategoryService } from '../location-category.service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-location-category-register',
  templateUrl: './location-category-register.component.html',
  styleUrls: ['./location-category-register.component.scss']
})
export class LocationCategoryRegisterComponent implements OnInit {
  location_category_register_form: FormGroup;
  action: string = '';
  constructor(private formBuilder: FormBuilder, private location_cat_service : LocationCategoryService, private http: HttpService, private global: GlobalService) { 
    this.location_category_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      location_category_name: [null, Validators.compose([Validators.required])],
    })

    if (this.location_cat_service.get_location_category_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.location_cat_service.get_location_category_data);
  }


  this.location_cat_service.LocationCategoryUpdate.subscribe((relation_data) => {
    if (relation_data === null) {
      this.action = 'register';
      this.location_category_register_form.reset();
    } else {
      this.action = 'update';
      this.setupUpdateForm(relation_data);
    }
  });

  this.location_cat_service.LocationCategoryUpdate.subscribe((relation_type) => {
    this.setupUpdateForm(relation_type);
});
  
}
  setupUpdateForm(element) {
    this.location_category_register_form.controls['id'].setValue(element['id']);
    this.location_category_register_form.controls['location_category_name'].setValue(element['name']);
  }

  registerLocationCategory() {
    const location_cat_data = Object.assign({}, this.location_category_register_form.value);
    console.log(location_cat_data)
    this.http.registerLocationCategory(location_cat_data).subscribe((data) => {
      this.global.showSnakeBar(data['message']);
      this.location_cat_service.downloadLocationCategory.emit(true);
    });
  }


  ngOnInit() {
  }

}
